<template>
<!--<div class="no-gutters pl-2">-->
  <div v-if="!isPending" class="revo-checkbox-container">

  <font-awesome-icon icon="exclamation" class="text-danger"
                     v-if="model && model.__formModel__ && model.__formModel__.currentAfterSaveStatus === 'ERROR'">
  </font-awesome-icon>
  <font-awesome-icon icon="pen" class="text-success" transform="shrink-3"
                     v-if="model && model.__formModel__ && model.__formModel__.currentAfterSaveStatus === 'EDITED'">
  </font-awesome-icon>
  <font-awesome-icon icon="sparkles" class="text-success"
                     v-if="model && model.__formModel__ && model.__formModel__.currentAfterSaveStatus === 'NEW'">
  </font-awesome-icon>
<!--  <b-form-checkbox class="pt-2" v-model="selectionStatus" v-if="column.multiSelectEnabled">-->
<!--  </b-form-checkbox>-->
  <b-form-checkbox v-model="selectionStatus" v-if="column.multiSelectEnabled">
  </b-form-checkbox>

</div>
<div v-else>...</div>

</template>

<script>
export default {
  name: "MetaRenderer",
  // access any cell properties here
  props: ["rowIndex", "prop", "model", "column", "data", "rowUid"],
  created() {
  },

  mounted(){
    if(this.dataGrid){
      this.refreshCallback = ()=>{
        this.intChange = true;
        this.selectionStatus = !!(this.model?.__meta__?.selected);
        this.intChange = false;
      };
      this.dataGrid.$on("refresh-meta-rq", this.refreshCallback);
      if(!this.registered){
        // TODO usunąć w momencie usuwania starego grida
        this.model?.__dataStream__?.registerMetaRenderer(this);
        this.registered = true;
      }
    }
  },
  beforeDestroy() {
    if(this.dataGrid) {
      this.dataGrid.$off("refresh-meta-rq", this.refreshCallback);
    }
  },
  methods: {
    refreshSelection: function(){
      this.selectionStatus = this.data[this.rowIndex]?.__meta__?.selected;
    }
  },
  data: function(){ return {
    selectionStatus: false,
    isPending: false,
  }},

  watch: {
    selectionStatus: function (val) {
      if (this.intChange) {
        return;
      }
      this.model = this.data[this.rowIndex];
      if (this.model.__pending__) {
        return;
      }
      if (!this.model?.__meta__) {
        this.model.__meta__ = {};
      }

      if (this.model) {
        this.model.__meta__.selected = val;
      }
      this.column.grid?.elementSelectionChange?.(this.model, val);

    },
    model: function (val) {
      this.isPending = this.data[this.rowIndex]?.__pending__;
      this.intChange = true;
      this.selectionStatus = !!(this.data[this.rowIndex]?.__meta__?.selected);
      this.intChange = false;

      //console.log(`M: ${this.rowIndex}/${this.isPending}`);

    },
    data: function (val) {
      this.intChange = true;

      this.model = this.data[this.rowIndex];
      this.isPending = val[this.rowIndex]?.__pending__;
      this.selectionStatus = !!(this.model?.__meta__?.selected);

      this.intChange = false;

      //console.log(`D: ${this.rowIndex}/${this.isPending}`);
    },
    prop: function (val) {
     // console.log(`P :${this.isPending}`);
    },
    column: function (val) {
    },
    rowIndex: function (val) {
      this.isPending = this.data[this.rowIndex]?.__pending__;
      this.model = this.data[this.rowIndex];
      //console.log(`R :${this.isPending}`);

    }
  }
}
</script>